(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('TransportTypeController', TransportTypeController);

    TransportTypeController.$inject = ['$scope', '$state', 'DataUtils', 'TransportType','NgTableParams'];

    function TransportTypeController ($scope, $state, DataUtils, TransportType,NgTableParams) {
        var vm = this;
        vm.transportType = [];
      /*  vm.transportType = [{code:'T01',type:'BK', description:'Bưu Kiện',status:'1'},
                            {code:'T02',type:'EMS', description:'Chuyển Phát Nhanh',status:'1'},
                            {code:'T03',type:'UT', description:'Ủy Thác',status:'1'},
                            {code:'T04',type:'DS', description:'Đường Sắt',status:'1'},
                            {code:'T05',type:'NB', description:'Công ty xe, messenger',status:'1'},
                            {code:'T06',type:'NV', description:'Nhân viên đến giao/nhận',status:'1'}];*/
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	TransportType.query(function(result) {
                vm.transportType = result;
                if(vm.transportType !=null && vm.transportType.length > 0){
                	var i;
                	for( i = 0; i < vm.transportType.length; i++){
                		if(vm.transportType[i].status == 1){
                			vm.transportType[i].statusName = true;
                		}else{
                			vm.transportType[i].statusName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.transportType
    				});
                }
            });
        }
    }
})();
